import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqData = [
  {
    question: "Quels documents faut-il pour souscrire ?",
    answer: (
      <ul className="list-disc pl-5">
        <li>Pièce d’identité valide, pour les parents</li>
        <li>Copie de l’extrait de naissance, pour les enfants</li>
        <li>Carte CMU pour chaque membre de la famille</li>
        <li>Certificat de scolarité, pour les enfants de 21 à 24 ans</li>
        <li>Copie de l’ancienne carte d’assurance ainsi que les états statistiques de consommation, au cas où vous étiez précédemment couvert par une autre compagnie</li>
      </ul>
    )
  },
  {
    question: "Quand ma couverture prend-elle effet ?",
    answer: "Après paiement de la prime et dès validation de la souscription, suivant les délais de carence mentionnés dans le contrat."
  },
  {
    question: "Puis-je ajouter ma famille à mon assurance ?",
    answer: "Oui, il est possible d’ajouter son/sa conjoint(e) et ses enfants, à tout moment."
  },
  {
    question: "Comment se passent les remboursements ?",
    answer: "Ils sont traités rapidement et de manière transparente, sur présentation des justificatifs de dépenses. Vous suivez chaque étape directement depuis votre Espace Client."
  }
];

export default function Accordion() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div>
      {faqData.map((item, index) => (
        <div key={index} >
          <button
            className="w-full text-left py-3 text-lg font-semibold text-secondary flex justify-between items-center"
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            {item.question}
            <span className={`transform transition ${openIndex === index ? 'rotate-180' : ''} border-2 border-black/50 rounded-full p-1`}>
              <ChevronDown size={24}/>
            </span>
          </button>
          <div className={`mt-2 text-[#212529] pt-3 overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 border-t border-gray-100' : 'max-h-0'}`}>
            <div className='text-start'>{item.answer}</div>
          </div>
        </div>
      ))}
    </div>
  );
}